import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function DetailCTA() {
  return (
    <Box component="section" sx={{ bgcolor: "white", py: 12 }}>
      <Box sx={{ maxWidth: 1280, mx: "auto", px: { xs: 2, md: 4 } }}>
        <Box sx={{
          bgcolor: "white", borderRadius: 4, p: { xs: 4, md: 6 },
          boxShadow: "0 4px 32px rgba(42,141,255,0.10)",
          border: "1px solid rgba(0,0,0,0.06)",
        }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} lg={9}>
              <Typography variant="overline" sx={{ fontWeight: 700, letterSpacing: "0.18em", color: "text.secondary", display: "block", mb: 1 }}>
                Next implementation layer
              </Typography>
              <Typography variant="h4" fontWeight={700} sx={{ fontSize: { xs: "1.5rem", md: "2.2rem" } }}>
                Ready for backend integration with Clerk, Prisma, PostgreSQL, Sanity, Algolia, Stripe, Razorpay, Cloudinary, and AWS.
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Button
                component={Link}
                to="/business"
                variant="outlined"
                size="large"
                endIcon={<ArrowRight size={18} />}
                fullWidth
                sx={{ borderRadius: 2, py: 1.5 }}
              >
                Explore Business
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}